<template>
<div class="modal-card" style="width: auto">
    <div>
      <div class="imgandcamera">
        <div class="circle">
          <div style="text-align: center;" v-if="imgUser != null">
            <img style="text-align: center"  :src="obtenerUrl(photography)" fluid alt="Responsive image"
                 class="profile-pic" width="160px" min-height="160px"/>
          </div>
          <div style="text-align: center;" v-else>
            <img style="text-align: center"  :src="urlImagenLogo" fluid alt="Responsive image"
                 class="profile-pic" width="160px" min-height="160px"/>
          </div>
        </div>

      </div>
    </div>
  <div>
    <file-pond
      labelFileProcessing="Subiendo tu imagen"
      labelFileProcessingComplete="Tu imagen se subió correctamente"
      labelFileProcessingAborted="Subida cancelada"
      labelFileProcessingError="Ocurrió un error al subir tu imagen"
      labelTapToCancel="Click para cancelar"
      :onprocessfile="onProcessFile"
      name="imagen"
      ref="pond"
      label-idle="Cambia tu imagen"
      allow-multiple="false"
      accepted-file-types="image/jpeg, image/png"
      :server="urlUpload"
      v-bind:files="imagen"
      v-on:init="handleFilePondInit"/>
  </div>

  <div class="aligText">

    <span class="iconChangeImg" @click="goEditProfile"><b-icon icon="content-save" /></span>
    <span class="iconChangeImg" @click="$parent.close()"><b-icon icon="close-circle" /></span>
  </div>
</div>
</template>
<script>
  // Import Vue FilePond
  import vueFilePond from 'vue-filepond';

  const endpointBase = __API__
  // Import FilePond styles
  import 'filepond/dist/filepond.min.css';

  // Import image preview plugin styles
  import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

  // Import image preview and file type validation plugins
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview';

  // Create component
  const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);
    export default {
      props: ['isEdit','idUser','imgUser'],
        name: "ChangeImage",
      data(){
          return{
            imagen: [],
            photography:null,
            urlUpload : `${__API__}images/imgs/subirimagen`,
            urlImagenLogo : '../../../../statics/img/user2.png',
            endpointBase
        }
      },
      mounted(){
        this.photography=this.imgUser

      },
      computed:{


      },
      methods:{
        goEditProfile(){
          const params = [
            `photography=${this.photography}`,

          ].join('&')
          this.$http.put(`api/personalByLogin?`+params)
            .then(response =>{
              //this.snackbar(msgeditsuccess);
              this.$parent.urlImagenLogo=this.obtenerUrl(this.photography)
              this.$parent.photography=this.photography
              this.$parent.close();


            }).catch(()=>{})
        },
        obtenerUrl(idimg){
          if(idimg == ""){
            this.urlImagenLogo = '../../../../statics/img/user2.png'
          }else{
            this.urlImagenLogo = this.endpointBase+'images/imgsPersonal/'+idimg

          }
          return this.urlImagenLogo
        },
        onProcessFile(error, file){
          console.log(error)
          console.log(file.serverId)
          this.cambiarImagenLogo(file.serverId)
          this.imagen= []

        },
        cambiarImagenLogo(idImagen){

          this.photography=idImagen
          this.urlImagenLogo=`${__API__}images/imgsPersonal/${idImagen}`
        },
        success(msg) {
          this.$buefy.toast.open(msg);
          /*this.$buefy.toast.open({
            message: 'Something happened correctly!',
            type: 'is-success'
          })*/
        },
        handleFilePondInit: function() {
          console.log('FilePond has initialized');

          // FilePond instance methods are available on `this.$refs.pond`
        },
        uploadImg(){

          this.$refs.inputFile.click()
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modal/ChangeImage.vue